import { cancelarAlert } from 'app/services/alerts';

const ATUALIZAR_REGISTRO = `_ATUALIZAR_REGISTRO`;
const VISUALIZAR = `_VISUALIZAR_SUCESSO`;
const CADASTRAR = `_CADASTRAR`;
const EDITAR = `_EDITAR_SUCESSO`;
const BUSCAR = `_BUSCAR_SUCESSO`;
const ERRO = `_ERRO`;
const SUCESSO = `_SUCESSO`;
const CARREGANDO = `_CARREGANDO`;
const CARREGAR_REGISTRO = `_CARREGAR_REGISTRO`;
const SELECIONADOS = `_SELECIONADOS`;
const LIMPAR_SELECAO = `_LIMPAR_SELECAO`;
const REQUEST_PARAMS = `_REQUEST_PARAMS`;
const EDITAR_VISUALIZAR = `_EDITAR_VISUALIZAR`;
const TIPO_SELECAO = `TIPO_SELECAO`;
const EXIBIR_GRAFICOS = `EXIBIR_GRAFICOS`;
const FECHAR_MODAL = `FECHAR_MODAL`;
const BUSCA_AVANCADA = `_BUSCA_AVANCADA`;
const FECHAR_IMPORT_MODAL = `_FECHAR_IMPORT_MODAL`;
const ABRIR_IMPORT_MODAL = `_ABRIR_IMPORT_MODAL`;

export const generateActionTypes = (BASE) => {
  return {
    ATUALIZAR_REGISTRO: `${BASE}${ATUALIZAR_REGISTRO}`,
    CADASTRAR: `${BASE}${CADASTRAR}`,
    EDITAR: `${BASE}${EDITAR}`,
    EDITAR_VISUALIZAR: `${BASE}${EDITAR_VISUALIZAR}`,
    VISUALIZAR: `${BASE}${VISUALIZAR}`,
    BUSCAR: `${BASE}${BUSCAR}`,
    CARREGANDO: `${BASE}${CARREGANDO}`,
    CARREGAR_REGISTRO: `${BASE}${CARREGAR_REGISTRO}`,
    SELECIONADOS: `${BASE}${SELECIONADOS}`,
    LIMPAR_SELECAO: `${BASE}${LIMPAR_SELECAO}`,
    SUCESSO: `${BASE}${SUCESSO}`,
    ERRO: `${BASE}${ERRO}`,
    REQUEST_PARAMS: `${BASE}${REQUEST_PARAMS}`,
    TIPO_SELECAO: `${BASE}${TIPO_SELECAO}`,
    EXIBIR_GRAFICOS: `${BASE}${EXIBIR_GRAFICOS}`,
    FECHAR_MODAL: `${BASE}${FECHAR_MODAL}`,
    BUSCA_AVANCADA: `${BASE}${BUSCA_AVANCADA}`,
    ABRIR_IMPORT_MODAL: `${BASE}${ABRIR_IMPORT_MODAL}`,
    FECHAR_IMPORT_MODAL: `${BASE}${FECHAR_IMPORT_MODAL}`,
  };
};

export function defaultReducer(state, action, types) {
  const { type, payload } = action;

  switch (type) {
    case types.ATUALIZAR_REGISTRO:
      return {
        ...state,
        registro: action.payload,
      };
    case types.ABRIR_IMPORT_MODAL: {
      return {
        ...state,
        abrirImportModal: true,
      };
    }
    case types.FECHAR_IMPORT_MODAL: {
      return {
        ...state,
        abrirImportModal: false,
      };
    }
    case types.CADASTRAR: {
      return {
        ...state,
        registro: payload,
        cadastrar: true,
        visualizar: false,
      };
    }
    case types.FECHAR_MODAL: {
      return {
        ...state,
        registro: undefined,
        cadastrar: false,
        visualizar: false,
        buscaAvancada: false,
      };
    }
    case types.EDITAR: {
      return { ...state, visualizar: false, cadastrar: true, registro: payload };
    }
    case types.VISUALIZAR: {
      return { ...state, visualizar: true, cadastrar: false, registro: payload };
    }
    case types.EDITAR_VISUALIZAR: {
      return { ...state, visualizar: false, cadastrar: true };
    }

    case types.BUSCAR: {
      return {
        ...state,
        visualizar: false,
        cadastrar: false,
        page: payload,
        selecionados: state.selecionados.filter((selecionado) => {
          return payload?.content?.filter((conteudo) => conteudo.id === selecionado.id).length > 0;
        }),
      };
    }
    case types.LIMPAR_SELECAO: {
      return { ...state, selecionados: [] };
    }
    case types.REQUEST_PARAMS: {
      return {
        ...state,
        requestParams: { ...state.requestParams, ...payload },
      };
    }
    case types.CARREGAR_REGISTRO: {
      return { ...state, carregandoRegistro: payload };
    }
    case types.CARREGANDO: {
      return { ...state, carregandoRegistros: payload };
    }

    case types.SELECIONADOS: {
      return { ...state, selecionados: payload };
    }
    case types.TIPO_SELECAO: {
      return { ...state, tipoSelecao: action.payload };
    }

    case types.ERRO:
      return {
        ...state,
        message: payload,
        registro: payload?.registro,
      };
    case types.SUCESSO: {
      return {
        ...state,
        message: payload,
        registro: payload?.registro,
        show: false,
        selecionados: [],
      };
    }
    case types.EXIBIR_GRAFICOS: {
      return {
        ...state,
        exibirGraficos: payload.exibir,
      };
    }
    case types.BUSCA_AVANCADA: {
      return {
        ...state,
        cadastrar: false,
        visualizar: false,
        buscaAvancada: true,
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${type}`);
    }
  }
}

export const generateDefaultActions = (types) => {
  return {
    atualizarRegistro: (payload) => {
      return {
        type: types.ATUALIZAR_REGISTRO,
        payload,
      };
    },
    carregandoRegistro: (payload) => {
      return { type: types.CARREGAR_REGISTRO, payload };
    },
    cadastrar: (payload) => {
      return {
        type: types.CADASTRAR,
        payload,
      };
    },
    editar: (payload) => {
      return {
        type: types.EDITAR,
        payload,
      };
    },
    visualizar: (payload) => {
      return {
        type: types.VISUALIZAR,
        payload,
      };
    },
    editarVisualizar: () => {
      return {
        type: types.EDITAR_VISUALIZAR,
      };
    },
    buscar: (payload) => {
      return {
        type: types.BUSCAR,
        payload,
      };
    },
    limparSelecao: () => {
      return {
        type: types.LIMPAR_SELECAO,
      };
    },
    setPesquisar: (q) => {
      return {
        type: types.REQUEST_PARAMS,
        payload: { q },
      };
    },
    setExibirGraficos: (exibir) => {
      return {
        type: types.EXIBIR_GRAFICOS,
        payload: { exibir },
      };
    },
    setCurrentPage: (page) => {
      return {
        type: types.REQUEST_PARAMS,
        payload: { page },
      };
    },
    setTipoSelecao: (payload) => {
      return {
        type: types.TIPO_SELECAO,
        payload,
      };
    },
    setPageSize: (size) => {
      return {
        type: types.REQUEST_PARAMS,
        payload: { size },
      };
    },
    setSorting: (sort) => {
      return {
        type: types.REQUEST_PARAMS,
        payload: { sort },
      };
    },
    setCarregarRegistro: (payload) => {
      return {
        type: types.CARREGAR_REGISTRO,
        payload,
      };
    },
    setCarregandoRegistros: (payload) => {
      return {
        type: types.CARREGANDO,
        payload,
      };
    },
    setSelecionados: (payload) => {
      return {
        type: types.SELECIONADOS,
        payload,
      };
    },
    sucesso: (message, registro) => {
      return { type: types.SUCESSO, payload: { message, variant: 'success', registro } };
    },
    erro: (message, registro) => {
      return { type: types.ERRO, payload: { message, variant: 'error', registro } };
    },
    warning: (message, registro) => {
      return { type: types.ERRO, payload: { message, variant: 'warning', registro } };
    },
    fecharModalCadastro: (dispatch, dirty) => {
      const action = {
        type: types.FECHAR_MODAL,
      };

      if (dirty) {
        cancelarAlert({
          confirmar: async () => {
            dispatch(action);
          },
        });
      } else {
        dispatch(action);
      }
    },
    buscaAvancada: () => {
      return {
        type: types.BUSCA_AVANCADA,
      };
    },
  };
};
